// extracted by mini-css-extract-plugin
export default {"container":"UpdateProfile_container__CelXu","menu":"UpdateProfile_menu__wrP7x","menuLink":"UpdateProfile_menuLink__BhZ3v","content":"UpdateProfile_content__CaWJO"};